export function prettyLog(category, ...args) {
    prettyOutput('log', category, ...args);
}

export function prettyWarn(category, ...args) {
    prettyOutput('warn', category, ...args);
}

export function prettyError(category, ...args) {
    prettyOutput('error', category, ...args);
}

function prettyOutput(severity, category, ...args) {
    let color = 'lightblue',
        out = console.log;
    if (severity === 'error') {
        color = 'lightcoral';
        out = console.error;
    } else if (severity === 'warn') {
        color = 'orange';
        out = console.warn;
    } else if (severity === 'debug') {
        color = 'grey';
        out = console.debug;
    }

    out(
        `%c[${category}]`,
        `background: ${color}; padding: 2px 5px; border-radius: 4px; font-weight: bold;`,
        ...args
    );
}
